module.exports = {
      id: "icon-audio-twitter-usage",
      viewBox: "0 0 25.209 25.209",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-audio-twitter",
      toString: function () {
        return this.url;
      }
    }